import React from "react";
import "./LeaderboardBox.scss";
import flagImg from "../../assets/icons/flag-usa.svg"; // Assuming the flag image is the same for all

function LeaderboardBox({
  image,
  name,
  country = "USA",
  profit,
  as,
  equity,
  gain,
}) {
  return (
    <div className="lb_box">
      <div className="bg_img">
        <img src={image} alt={name} />
      </div>
      <div className="lb_box_header">
        <h2>{name}</h2>
        <div className="lb_box_header_right">
          <img src={flagImg} alt={country} />
          <p>{country}</p>
        </div>
      </div>
      <div className="lb_box_details">
        <div>
          <span>Profit</span>
          <p>${profit}</p>
        </div>
        <div>
          <span>Account Size</span>
          <p>${as}</p>
        </div>
        <div>
          <span>Equity</span>
          <p>${equity}</p>
        </div>
        <div>
          <span>Gain</span>
          <p>{gain}%</p>
        </div>
      </div>
    </div>
  );
}

export default LeaderboardBox;
